<template>
  <ElInput
    class="phone-number"
    v-model="inputValue"
    :placeholder="placeholder"
    @keyup="checkValidity"
    ref="phoneInputRef"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ElInput } from "element-plus";

import intlTelInput, { type Iti, type SomeOptions } from "intl-tel-input";

const itiOptions: SomeOptions = {
  separateDialCode: true,
  formatOnDisplay: true,
  autoPlaceholder: "aggressive",
  // Due to https://github.com/jackocnr/intl-tel-input/pull/1929
  // @ts-expect-error: Cannot find module 'intl-tel-input/utils'
  loadUtils: () => import("intl-tel-input/build/js/utils.js"),
  initialCountry: "us",
  countrySearch: false,
  dropdownContainer: document.body,
};

@Options({
  props: {
    placeholder: String,
    value: String,
  },
})
export default class PhoneNumber extends Vue {
  value!: string;
  placeholder!: string;

  iti!: Iti;

  readonly INPUT_PADDING_OFFSET = 10;

  get inputValue(): string {
    return this.value;
  }

  set inputValue(value: string) {
    this.$emit("value", value);
    this.$emit("fullNumber", this.iti.getNumber());
  }

  mounted(): void {
    const phoneInputRef = this.$refs.phoneInputRef as typeof ElInput;
    const phoneInputElement = phoneInputRef.input as HTMLInputElement;
    this.iti = intlTelInput(phoneInputElement, {
      ...itiOptions,
      customPlaceholder: () => {
        this.adjustInputPadding(phoneInputElement);
        return this.placeholder;
      },
    });
  }

  beforeUnmount(): void {
    this.iti.destroy();
  }

  checkValidity(): void {
    this.$emit("valid", this.iti.getValidationError() === 0);
  }

  private adjustInputPadding(element: HTMLInputElement): void {
    const paddingLeftNumber = parseInt(element.style.paddingLeft, 10);
    element.style.paddingLeft = `${
      paddingLeftNumber + this.INPUT_PADDING_OFFSET
    }px`;
  }
}
</script>

<style lang="scss">
.phone-number {
  .iti {
    width: 100%;

    &__arrow {
      border: solid var(--primary-text-color);
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(45deg);
      margin: 0 6px 0 12px;
      border-radius: 1px;

      &--up {
        transform: rotate(-135deg);
      }
    }

    &--separate-dial-code {
      .iti__selected-flag {
        background: var(--white-color);
      }
    }

    &__flag-container {
      border-right: 1px solid var(--border-color);
      z-index: 10;
      margin-right: 11px;
    }

    .el-input__inner {
      padding-left: 80px;
    }
  }
}
</style>
